import { Box, TextField, Typography, theme } from '@dtx-company/design-system/src'
import { PlanPurchaseFormFieldWrapper } from '@app/plans/src/PlanPurchaseFormFieldWrapper/PlanPurchaseFormFieldWrapper'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useBuyPlanPageContext } from '../../context/useBuyPlanPageContext'
import React, { useState } from 'react'

export const BuyPlanPageOrgName: React.FC = () => {
  const { document, showOrgName } = useBuyPlanPageContext()
  const { data } = document
  const [lastValue, setLastValue] = useState('')

  if (!showOrgName) return null
  return (
    <Box sx={{ my: theme.spacing(12) }}>
      {data.org_name_heading && (
        <Box
          sx={{
            mt: 12,
            mb: 2
          }}
        >
          <Typography variant="headlineXSmall" component="h2">
            {data.org_name_heading}
          </Typography>
        </Box>
      )}
      {data.org_name_description && (
        <Typography variant="bodyMedium">{data.org_name_description}</Typography>
      )}
      <Box sx={{ mt: 4 }}>
        <PlanPurchaseFormFieldWrapper name="orgName">
          <TextField
            hiddenLabel
            size="small"
            label={data.org_name_label || ''}
            fullWidth
            InputProps={{
              onBlur: e => {
                if (e.target.value !== lastValue) {
                  fireAnalyticsEvent('BuyPlanPage_OrgNameInput_Changed', { value: e.target.value })
                }
                setLastValue(e.target.value)
              }
            }}
          />
        </PlanPurchaseFormFieldWrapper>
      </Box>
    </Box>
  )
}
